// TIP 这里定义所有设置state方法的名称，即定义mutations中方法的名称
export const mutationTypes = {
  SET_MOBILERIGHTNAVSHOW: 'SET_MOBILERIGHTNAVSHOW', // 手机右侧导航栏，显示。
  SET_USERNAME: 'SET_USERNAME', // 用户名
  SET_TOKEN: 'SET_TOKEN', // 登录凭证
  SET_EXPIRETIME: 'SET_EXPIRETIME', // Token过期时间
  SET_LASTUPDATETIME: 'SET_LASTUPDATETIME', // 最后更新时间
  SET_LANG: 'SET_LANG', // 当前语言
  SET_LANGS: 'SET_LANGS', // 所有语种列表
  SET_ASSETS: 'SET_ASSETS',
  SET_MARKETLIST: 'SET_MARKETLIST', // 所有交易市场列表
  SET_CURRENTMARKET: 'SET_CURRENTMARKET', // 当前交易市场
  SET_USERINFO: 'SET_USERINFO', // 用户信息
  SET_USER_VIP: 'SET_USER_VIP',
  SET_CURRENCY: 'SET_CURRENCY', // 当前法币
  SET_CURRENCIES: 'SET_CURRENCIES', // 所有法币列表
  SET_ALL_COIN: 'SET_ALL_COIN',
  SET_UNREADMESSAGECOUNT: 'SET_UNREADMESSAGECOUNT', // 未读消息数量
  SET_INFOMATIONNAV: 'SET_INFOMATIONNAV', // 资讯研究的二级导航
  SET_SOCKET_STATUS: 'SET_SOCKET_STATUS', // Socket连接状态
  SET_ISLOGIN: 'SET_ISLOGIN', // 是否登录
  SET_SLIDERMENUCONTROLS: 'SET_SLIDERMENUCONTROLS', // 移动端侧滑菜单显示与隐藏
  SET_COIN_LIST: 'SET_COIN_LIST', // 设置，所有币种，列表
  SET_TRADING_PAIRS_LIST: 'SET_TRADING_PAIRS_LIST', // 设置，所有币币交易对，列表
  SET_COLLECTED_MARKETS_SYMBOLS: 'SET_COLLECTED_MARKETS_SYMBOLS', // 设置，收藏的交易对id列表
  SET_FOR_MOBILE: 'SET_FOR_MOBILE',
  SET_SOCKET_STATE: 'SET_SOCKET_STATE',
  SET_BURGER_MENU_STATE: 'SET_BURGER_MENU_STATE',
  SET_WECHAT_QRCODE_STATE: 'SET_WECHAT_QRCODE_STATE', // wechat qr code
  SET_AFFILIATE_PARTNER_INFO: 'SET_AFFILIATE_PARTNER_INFO',
  SET_PARTNER_INFO: 'SET_PARTNER_INFO',
  SET_PARTNER_TYPE: 'SET_PARTNER_TYPE',
  SET_AFFILIATE_TYPE: 'SET_AFFILIATE_TYPE',
  SET_REWARD_CATEGORIES: 'SET_REWARD_CATEGORIES',
};
